export const getDefaultSelectValue = () => {
    return document.querySelector("[data-select-first-option-text]")?.dataset?.selectFirstOptionText || 'Select';
}

export const defaultDatepickerSetup = { 
    "minDate": null, 
    "maxDate": null, 
    "format": "MM-DD-YYYY", 
    "dateRange": 0, 
    "yearRange": [1923, 2033], 
    "preventDefault": false, 
    "disableWeekends": false, 
    "disableDays": null 
}

export const dateOfPatientFittingDatepickerSetup = {
    ...defaultDatepickerSetup
}